import { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { IDigitalAddress, IEmailInput } from '../../../types/contact';
import { Form, FormFeedback, FormGroup, Input } from 'reactstrap';
import { validEmail } from '../../../utils/commons';

export type IndividualEmailHandler = {
    getEmail: () => IEmailInput;
    validate: (inclMandatoryCheck: boolean) => boolean;
}

type IndividualDigitalAddressDetailsProps = {
    digitalAddress?: IDigitalAddress;
    onChange: () => void;
}

const IndividualDigitalAddressDetails = forwardRef<IndividualEmailHandler, IndividualDigitalAddressDetailsProps>((props: IndividualDigitalAddressDetailsProps, ref:ForwardedRef<any>) => {
    const  {digitalAddress,  onChange} = props

    const [emailInput, setEmailInput] = useState<IEmailInput>({ digitalAddressId: digitalAddress?.id || 0, address: digitalAddress?.emailAddressTxt || '' })
    const [addressError, setAddressError] = useState('')

    useEffect(() => {
        setEmailInput({
            digitalAddressId: digitalAddress?.id || 0,
            address: digitalAddress?.emailAddressTxt || ''
        })
    }, [digitalAddress])

    useEffect(() => {
        onChange()
    }, [emailInput])

    useImperativeHandle(ref, () => ({
        getEmail(): IEmailInput {
            return emailInput!
        },
        validate(inclMandatoryCheck: boolean): boolean {
            let isValid: boolean = !addressError
            if (isValid && inclMandatoryCheck) {
                if (!emailInput?.address) {
                    setAddressError('Email address is required.')
                    isValid = false
                } else if (!validEmail(emailInput?.address)) {
                    setAddressError("Please input a valid email address.")
                    return false
                } 
            }
        
            return isValid
        }
    }), [emailInput])

    const changeAddress = (event: any) => {
        validateAddress(event.target.value.trim())
        setEmailInput({...emailInput, address: event.target.value.trim()})
    }

    const validateAddress = (address: string): boolean => {
        if (!address || validEmail(address) && address.length <= 100) {
            setAddressError('')
        } 
        if (address.length > 100) {
            setAddressError("This value is too long. It should have 100 characters or fewer.")
            return false
        } 
        return true
    }

    return (
        <Form>
            <FormGroup>
                <div className='row'>
                    
                    <div className='col-md-4'><label htmlFor="digitalAddress">Email Address: (required)</label></div>
                    <div className='col-md-8'>
                        <Input id="digitalAddress" 
                            type="text" 
                            style={{width: '100%'}} 
                            value={emailInput?.address} 
                            onChange={changeAddress} 
                            placeholder='Enter an address'
                            invalid={!!addressError}
                            required
                        />
                        <FormFeedback>{addressError}</FormFeedback>
                    </div>
                </div>
            </FormGroup>
        </Form>
    )
})

export default IndividualDigitalAddressDetails